/* eslint-disable no-unused-vars */
var NAVIGATION_REQUEST_START = "START",
    NAVIGATION_REQUEST_RESUME_ALL = "RESUME ALL",
    NAVIGATION_REQUEST_CONTINUE = "CONTINUE",
    NAVIGATION_REQUEST_PREVIOUS = "PREVIOUS",
    NAVIGATION_REQUEST_FORWARD = "FORWARD",
    NAVIGATION_REQUEST_BACKWARD = "BACKWARD",
    NAVIGATION_REQUEST_CHOICE = "CHOICE",
    NAVIGATION_REQUEST_EXIT = "EXIT",
    NAVIGATION_REQUEST_EXIT_ALL = "EXIT ALL",
    NAVIGATION_REQUEST_SUSPEND_ALL = "SUSPEND ALL",
    NAVIGATION_REQUEST_ABANDON = "ABANDON",
    NAVIGATION_REQUEST_ABANDON_ALL = "ABANDON ALL",
    NAVIGATION_REQUEST_NOT_VALID = "INVALID",
    NAVIGATION_REQUEST_JUMP = "JUMP",
    NAVIGATION_REQUEST_DISPLAY_MESSAGE = "DISPLAY MESSAGE",
    NAVIGATION_REQUEST_EXIT_PLAYER = "EXIT PLAYER";
/* eslint-enable no-unused-vars */

function NavigationRequest (type, targetActivity, messageToUser) {
    this.Type = type;
    this.TargetActivity = targetActivity;
    this.MessageToUser = messageToUser;
}

NavigationRequest.prototype = {
    toString: function () {
        return "Type=" + this.Type + ", TargetActivity=" + this.TargetActivity + ", MessageToUser=" + this.MessageToUser;
    },

    toDescriptiveString: function () {
        var ret = "";

        ret += this.Type;

        if (this.TargetActivity !== null) {
            ret += " targeting \"" + this.TargetActivity + "\".";
        }

        return ret;
    }
};
